import { render, staticRenderFns } from "./PageProduitsHorsMarche.vue?vue&type=template&id=2cfa250c&"
import script from "./PageProduitsHorsMarche.vue?vue&type=script&lang=js&"
export * from "./PageProduitsHorsMarche.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports